/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EComponentType } from "../types/EComponentType.ts";

/**
 * @description 1 = SingleChoice | 2 = MultipleChoice | 3 = SingleLineText | 4 = MultilineText | 5 = Numeric | 6 = Grade | 7 = Audio | 8 = Attachment |
 */
export const eComponentTypeSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
  ])
  .describe(
    "1 = SingleChoice | 2 = MultipleChoice | 3 = SingleLineText | 4 = MultilineText | 5 = Numeric | 6 = Grade | 7 = Audio | 8 = Attachment | ",
  ) as unknown as ToZod<EComponentType>;
